module.exports = __webpack_public_path__ + "static/media/award-1-01.44a34dec.svg";